import { createHtml } from './common-functions'
import { createBlockerEl, getHostnameFromEmbedUrl } from './video-block'

const findAppendPos = (targetLi) => {
  const targetLiScrollTop = targetLi.offsetTop
  let appendLi

  Array.from(document.querySelectorAll('.webinarlistingpage #listWrapper li')).every((li) => {
    if (li.offsetTop > targetLiScrollTop) {
      return false
    }
    appendLi = li
    return true
  })

  return appendLi
}

const setupConsent = (iframe, isIframeBlocked) => {
  const hostname = getHostnameFromEmbedUrl(iframe.getAttribute('data-iframe-src'))

  if (hostname) {
    let blockerElement = iframe.parentElement.querySelector('.block-content')

    if (!blockerElement) {
      blockerElement = createBlockerEl()
      iframe.insertAdjacentElement('afterend', blockerElement);
    }

    if (isIframeBlocked) {
      iframe.classList.add('d-none')
      iframe.src = ""
      blockerElement.classList.add('d-block');
      blockerElement.classList.remove('d-none');
    } else {
      iframe.src = iframe.getAttribute('data-iframe-src')
      blockerElement.classList.add('d-none');
      blockerElement.classList.remove('d-block');
      iframe.classList.remove('d-none');
    }
  }
}

export const createVideoContainer = (element, title, closeTxt) => {
  const targetElement = document.getElementById(element)
  const videoUrl = targetElement.getAttribute('data-video-url')
  const currentPos = window.scrollY
  const isQcVideo = targetElement.getAttribute('data-qc-video') === 'true'

  const videoIframe = targetElement.getAttribute('data-youtube') === 'true' && videoUrl ?
    `<iframe class="d-none" id="ytvideo" frameborder="0" allowfullscreen referrerpolicy="strict-origin" scrolling="no" allowtransparency="true" allow="autoplay; encrypted-media" title="Youtube video: ${title}" data-iframe-src="${videoUrl}?wmode=transparent&enablejsapi=1&version=3&playerapiid=ytplayer" wmode="Opaque"></iframe>` :
    `<iframe class="d-none" data-iframe-src="${videoUrl}" title="Video: ${title}"></iframe>`

  const videoHtmlString = `<li id="video-${element}" class="col-12 video-container">
      <div class="bg-white">
        <div class="d-block d-md-none p-3">
          <h4 class="title mb-0">${title}</h4>
        </div>
        <div class="video ratio ratio-16x9">${videoIframe}</div>
        <div class="row p-3">
          <div class="col-6 d-none d-md-block">
            <h4 class="title mb-0">${title}</h4>
          </div>
          <div class="col-12 col-md-6 text-end">
            <a role="button" type="button" class="btn btn-peach close">${closeTxt}</a>
          </div>
        </div>
      </div>
    </li>`

  const videoTemplate = createHtml(videoHtmlString)

  const closeHandler = (e) => {
    e.target.closest('.video-container').remove()
    window.scrollTo(0, currentPos)
    targetElement.setAttribute('aria-expanded', 'false')
  }

  const iframe = videoTemplate.querySelector('iframe')

  if (isQcVideo) {
    setupConsent(iframe, false)
  } else {
    const activeGroups = window['OnetrustActiveGroups']
    setupConsent(iframe, activeGroups && !activeGroups.includes('C0004'))

    const handleConsentChange = (e) => {
      setupConsent(iframe, !e.detail.includes('C0004'))
    }

    window.addEventListener("OneTrustGroupsUpdated", handleConsentChange);
  }

  videoTemplate.querySelector('.btn.close').addEventListener('click', closeHandler)

  const insertBeforeElement = findAppendPos(targetElement.closest('li'))
  insertBeforeElement.after(videoTemplate)
  videoTemplate.scrollIntoView({ behavior: "smooth", block: "center" })
  targetElement.setAttribute('aria-expanded', 'true')
}